var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocationIconcomponent = function SvgLocationIconcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 6.75A5.246 5.246 0 0 1 9 1.5a5.246 5.246 0 0 1 5.25 5.25C14.25 10.688 9 16.5 9 16.5s-5.25-5.813-5.25-9.75Zm3.375 0a1.876 1.876 0 1 0 3.751-.001 1.876 1.876 0 0 0-3.751.001Z",
    fill: "#CECCC9"
  })));
};
export default SvgLocationIconcomponent;